<template>
	<div @click="close_selection += 1">
		<ProgressLinear v-if="loading"/>
		<v-alert dense class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ errorMessageFormat(error_msg) }}
		</v-alert>
		<template v-if="!loading">
			<v-row class="mx-4 mt-5 mb-0" :justify="$vuetify.breakpoint.smAndUp ? 'space-between':'start'" align="center">
				<div>
					<span class="file-list-title" style="color: #4742C6">Exceptions&nbsp;</span>
					<span class="file-list-text" style="color: #F45252; font-size: 16px; font-weight: 700;">&nbsp;{{ exception_holding_num }}&nbsp;new</span>
				</div>
				<v-row class="ma-0 py-1" :justify="$vuetify.breakpoint.smAndUp ? 'end':'space-between'" align="center">
					<v-checkbox
						key="include_rejected"
						class="mt-0 pt-0"
						v-model="include_rejected"
						:color="color"
						hide-details
						@change="onIncludeRejectedCheckBox($event)"
					>
						<template v-slot:label>
							<span class="file-list-text">Include Rejected</span>
						</template>
					</v-checkbox>
					<v-menu v-model="filter_menu_visible" offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:style="isFilterDiff ? 'border: 1px solid #605AF6':''"
								class="text-capitalize ml-4 px-3"
								color="#FAFAFA"
								max-height="32"
								min-height="32"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon color="#82899B" size="20" class="mr-2">mdi-filter-variant</v-icon>
								<span class="mr-3 font-bold-style" style="color: rgba(25, 42, 62, 0.7)">Filters</span>
								<v-icon v-if="!filter_menu_visible" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-else color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div class="filter-menu-wrap mt-1" @click.stop>
							<div class="px-3 pt-3 pb-0">
								<v-checkbox
									v-model="filter_options.new_bookings"
									class="filter-menu-checkbox"
									:color="color"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">New bookings</span>
									</template>
								</v-checkbox>
								<v-checkbox
									v-model="filter_options.changed_bookings"
									class="filter-menu-checkbox"
									:color="color"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Changed bookings</span>
									</template>
								</v-checkbox>
							</div>
							<v-divider/>
							<div class="filter-menu-label px-3 py-1">Show only:</div>
							<div class="px-3 pb-0">
								<v-checkbox
									v-model="filter_options.material_key"
									class="filter-menu-checkbox"
									:color="color"
									:disabled="!filter_options.changed_bookings"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Material key no. changes</span>
									</template>
								</v-checkbox>
								<v-checkbox
									v-model="filter_options.rate_fc"
									class="filter-menu-checkbox"
									:color="color"
									:disabled="!filter_options.changed_bookings"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Supplier rate changes</span>
									</template>
								</v-checkbox>
								<v-checkbox
									v-model="filter_options.day_time"
									class="filter-menu-checkbox"
									:color="color"
									:disabled="!filter_options.changed_bookings"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Day / Time changes</span>
									</template>
								</v-checkbox>
								<v-checkbox
									v-model="filter_options.contract_ref"
									class="filter-menu-checkbox"
									:color="color"
									:disabled="!filter_options.changed_bookings"
									hide-details
								>
									<template v-slot:label>
										<span class="filter-menu-label">Contract ref changes</span>
									</template>
								</v-checkbox>
							</div>
						</div>
					</v-menu>
					<v-menu offset-y :close-on-content-click="false">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
								class="text-capitalize ml-4 px-3"
								color="#FAFAFA"
								max-height="32"
								min-height="32"
								v-bind="attrs"
								v-on="on"
								@click="is_down = !is_down"
							>
								<ColumnsTable :color="'#82899B'" width="20" height="20" class="mr-2"/>
								<span class="mr-3 font-bold-style" style="color: rgba(25, 42, 62, 0.7)">Columns</span>
								<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
								<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
							</v-btn>
						</template>
						<div style="min-width: 226px;height: 68vh;background-color: white;">
							<div class="tree-wrap">
								<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
									<v-list-item dense>
										<v-checkbox
											class="mt-0 pt-0"
											v-model="select_columns"
											:label="item.text"
											:value="item"
											:color="color"
											dense
											hide-details
											@change="onSelectColumn()"
										></v-checkbox>
									</v-list-item>
								</div>
							</div>
						</div>
					</v-menu>
				</v-row>
			</v-row>
			<v-expansion-panels v-model="panel" flat accordion readonly>
				<v-expansion-panel v-for="(detail, i) in panel_details" :key="i">
					<v-expansion-panel-header class="no-header-hover" style="padding: 0 16px; align-items: flex-start; min-height: 48px;">
						<v-row class="panel-header font-bold-style ma-0" style="line-height: 36px;">
							<div class="my-1 px-1 panel-toggle-target" style="background-color: #FAFAFA; height: 40px" :style="`color: ${color}`" @click.stop="togglePanel(i)">{{ detail.job.jocode }} - {{ detail.job.joshort }}</div>
							<v-menu
								:key="detail.id"
								v-model="detail.menu"
								:close-on-content-click="false"
								offset-y
								min-width="auto"
								@click.stop
							>
								<template v-slot:activator="{ on, attrs }">
									<v-row v-bind="attrs" v-on="on" class="mx-4 my-1 px-3" style="max-width: 160px; background-color: #FAFAFA; flex-wrap: nowrap;" align="center">
										<div style="width: 24px; height: 28px">
											<Calendar :color="'rgba(25, 42, 62, 0.5)'" width="20" height="20"/>
										</div>
										<div class="font-bold-style">{{ formatDateRange(detail.date) }}</div>
									</v-row>
								</template>
								<v-card @click.stop>
									<v-date-picker
										v-model="detail.date"
										:color="color"
										:picker-date.sync="detail.month"
										no-title
										multiple
										scrollable
										range
										@change="onDateChange($event, detail.id)">
									</v-date-picker>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastWeek(detail.id)">Last week</v-btn>
									</v-row>
									<v-row class="ma-0">
										<v-btn text class="text-capitalize" :color="color" @click.stop="onLastMonth(detail.id)">Last month</v-btn>
									</v-row>
								</v-card>
							</v-menu>
							<div class="mr-4 my-1" style="width: 240px" @click.stop>
								<v-select
									v-model="detail.phase"
									:color="color"
									:menu-props="{ bottom: true, offsetY: true}"
									:loading="detail.phase_loading"
									:items="detail.phase_items"
									item-value="id"
									item-text="desc"
									item-color="media"
									background-color="#FAFAFA"
									placeholder="Apply phase to selected"
									outlined
									dense
									hide-details
									return-object
									@change="onPhaseChange($event, detail)"
								>
									<template v-slot:selection="{ item }">
										<span class="font-normal-style font-header-style">{{ item.desc }}</span>
									</template>
								</v-select>
							</div>
							<v-btn
								class="white--text text-capitalize px-2 mr-4 my-1"
								:color="color"
								:disabled="detail.active_num === 0 || detail.accept_loading || detail.acc_holding_flag || detail.acc_job_flag"
								max-height="40"
								min-height="40"
								@click.stop="onAccept(detail)"
							>
								<v-icon v-if="!detail.accept_loading && !detail.acc_holding_flag && !detail.acc_job_flag" size="24" class="mr-1">mdi-check</v-icon>
								<v-progress-circular
									v-else
									class="ml-2"
									:size="16"
									:width="2"
									color="rgba(0, 0, 0, 0.26)"
									indeterminate
								/>
								<span class="button-text">Accept/Create Bookings ({{ detail.active_num }})</span>
							</v-btn>
							<v-btn
								class="white--text text-capitalize px-2 mr-4 my-1"
								:color="'#F45252'"
								:disabled="detail.reject_num === 0 || detail.reject_holding_flag || detail.reject_job_flag"
								max-height="40"
								min-height="40"
								@click.stop="onReject(detail)"
							>
								<v-icon v-if="!detail.reject_holding_flag && !detail.reject_job_flag" size="24" class="mr-1">mdi-close</v-icon>
								<v-progress-circular
									v-else
									class="ml-2"
									:size="16"
									:width="2"
									color="rgba(0, 0, 0, 0.26)"
									indeterminate
								/>
								<span class="button-text">Reject ({{ detail.reject_num }})</span>
							</v-btn>
							<v-btn
								class="white--text text-capitalize px-2 my-1"
								:color="color"
								:disabled="detail.copy_num === 0"
								max-height="40"
								min-height="40"
								@click.stop="onCopySelected()"
							>
								<v-icon size="22" class="mr-1">mdi-content-copy</v-icon>
								<span class="button-text">Copy selected ({{ detail.copy_num }})</span>
							</v-btn>
						</v-row>
						<template v-slot:actions>
							<v-row class="panel-icon panel-toggle-target mt-2 mx-0 mb-0 px-2" style="background-color: #FAFAFA; height: 40px;" @click.stop="togglePanel(i)">
								<v-icon v-if="detail.down" :color="color">mdi-chevron-up</v-icon>
								<v-icon v-if="!detail.down" :color="color">mdi-chevron-down</v-icon>
							</v-row>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-data-table
							:headers="headers"
							:items="detail['holdings']"
							:items-per-page="countPerpage"
							:page.sync="page"
							:loading="detail.table_loading"
							item-key="id"
							hide-default-header
							hide-default-footer
						>
							<template v-slot:header="{ props: { headers } }">
								<thead>
									<tr>
										<th v-for="header in headers" :key="header.value" class="header-background-color" :class="{ 'sticky-checkbox-column': header.value === 'checkbox' }">
											<v-row class="ma-0 px-3 table-header-row">
												<v-checkbox
													v-if="header.value === 'checkbox'"
													class="ma-0 pa-0"
													v-model="detail.check"
													:color="color"
													hide-details
													@change="onCheckBoxAll($event, detail.id)"
												>
												</v-checkbox>
												<span class="font-bold-style font-header-style">{{ header.text }}&nbsp;</span>
											</v-row>
										</th>
									</tr>
								</thead>
							</template>
							<template v-slot:body="{ items, headers }">
								<tbody>
									<template v-if="items.length === 0">
										<tr>
											<td :colspan="headers.length">
												<v-row class="font-normal-style font-header-style ma-0 px-3" justify="start" style="line-height: 48px">
													<div class="font-bold-style font-header-style mx-2" style="font-size: 16px;">{{ detail.table_text }}</div>
												</v-row>
											</td>
										</tr>
									</template>
									<template v-else>
										<tr v-for="(item_obj, index) in items" :key="index" :style="item_obj.parent_id !== 0 ? 'background-color: #FAFAFF': (item_obj.status_reject === reject_status ? 'background-color: #FFEFEF':'background-color: #FFFFFF')">
											<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="getRowStyle(item_obj)" :class="{ 'sticky-checkbox-column sticky-checkbox-cell': key === 'checkbox', 'sticky-checkbox-cell-child': key === 'checkbox' && item_obj.parent_id !== 0, 'sticky-checkbox-cell-reject': key === 'checkbox' && item_obj.parent_id === 0 && item_obj.status_reject === reject_status }">
												<div v-if="key === 'checkbox'" class="holding-cell holding-cell-checkbox">
													<v-row justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<v-checkbox
															v-if="item_obj.parent_id === 0 && item_obj.status_reject !== reject_status"
															:key="item_obj.id"
															v-model="item_obj.checkbox"
															:color="color"
															@change="onCheckBox(detail.id)"
														></v-checkbox>
														<v-tooltip v-if="item_obj.parent_id === 0 && item_obj.status_reject === reject_status" top>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																	v-bind="attrs"
																	v-on="on"
																	icon
																	small
																	@click.stop="onUndo(item_obj, detail)"
																>
																	<v-icon color="#EE0202" size="24" class="mr-1">mdi-restore</v-icon>
																</v-btn>
															</template>
															<span>Undo Reject</span>
														</v-tooltip>
													</v-row>
												</div>
												<div v-if="key === 'phase'" class="holding-cell">
													<v-row justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item_obj.original_phase" class="long-text font-normal-style">{{ item.desc }}</span>
														<v-select
															v-else
															class="phase-placeholder-red phase-select-auto-width"
															:color="color"
															v-model="item_obj.phase"
															background-color="transparent"
															:menu-props="{ bottom: true, offsetY: true}"
															:items="detail.phase_items"
															:error="item_obj.phase === null"
															:placeholder="item_obj.phase === null ? 'Select phase':''"
															item-value="id"
															item-text="desc"
															item-color="color"
															outlined
															dense
															hide-details
															return-object
															@change="onTablePhaseChange($event, detail)"
														>
															<template v-slot:selection="{ item }">
																<span class="font-normal-style font-header-style phase-select-single-line">{{ item.desc }}</span>
															</template>
														</v-select>
													</v-row>
												</div>
												<div v-if="key === 'outlet'" class="holding-cell">
													<v-row justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item_obj.original_outlet" class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item ? item.desc : '' }}</span>
														<v-autocomplete
															v-else
															v-model="item_obj.outlet"
															style="max-width: 180px;"
															:color="color"
															background-color="transparent"
															:menu-props="{ bottom: true, offsetY: true}"
															:items="supplier_items"
															:error="item_obj.outlet === null"
															item-value="id"
															item-text="desc"
															item-color="color"
															outlined
															dense
															hide-details
															return-object
															@change="onOutletChange($event, item_obj)"
														>
														</v-autocomplete>
													</v-row>
												</div>
												<div v-if="key === 'kind'" class="holding-cell">
													<v-row justify="start" align="center" class="font-normal-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item" class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item ? item.display_name : '' }}</span>
														<KindTreeSelection
															v-else
															style="max-width: 180px;"
															:color="color"
															:bgColor="'transparent'"
															:kindParams="kind_params"
															:kindSelected="item"
															:closeSelection="close_selection"
															:error="item_obj.kind === null"
															:isWidthAuto="true"
															@kind-selected="onKindChange($event, item_obj)"
														/>
													</v-row>
												</div>
												<div v-if="key === 'station_name'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<v-card tile elevation="0" color="transparent">
															<span class="font-normal-style truncate-2" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
														</v-card>
													</v-row>
												</div>
												<div v-if="key === 'media_reference_id'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
														<v-btn v-if="item" icon small class="ml-3" @click.stop="onHistoryClick(item)">
															<v-icon color="rgba(25, 42, 62, 0.25)" size="22">mdi-history</v-icon>
														</v-btn>
													</v-row>
												</div>
												<div v-if="key === 'contract_ref'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item.length === 0 ? '' : formatDate(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_day_flags'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-for="(flag, index) in item" :key="index" class="font-normal-style mr-1" style="color:#605AF6">
															<span v-if="flag === '1'" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ week_flag[index] }}&nbsp;</span>
															<span v-else>-&nbsp;</span>
														</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_duration'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_start_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'booking_end_time'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'rate_fc'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="item !== null && item_obj.cost_currency" class="font-normal-style mr-1">{{ item_obj.cost_currency.symbol }}</span>
														<v-icon v-if="item !== null && !item_obj.cost_currency" small class="mx-1">mdi-currency-usd</v-icon>
														<span v-if="item !== null" class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'value_fc'" class="holding-cell">
													<v-row v-if="item !== null" justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span v-if="system_rate_by_job[`${item_obj.job_id}`]" class="font-normal-style mr-1">{{ system_rate_by_job[`${item_obj.job_id}`].symbol }}</span>
														<v-icon v-else small class="mx-1">mdi-currency-usd</v-icon>
														<span class="font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ formatNumber(item) }}</span>
													</v-row>
												</div>
												<div v-if="key === 'program_name'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'pos_in_break'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'material_key_identifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'priority_modifier'" class="holding-cell">
													<v-row justify="start" align="center" class="font-bold-style font-header-style ma-0 px-3" style="flex-wrap: nowrap; height: 48px">
														<span class="long-text font-normal-style truncate-2" :style="item_obj[`${diff_flag}${key}`] ? 'color: #F45252':''">{{ item }}</span>
													</v-row>
												</div>
												<div v-if="key === 'custom1'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom2'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom3'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom4'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
												<div v-if="key === 'custom5'" class="holding-cell">
													<v-card tile elevation="0" color="transparent">
														<span class="font-normal-style truncate-2">{{ item }}</span>
													</v-card>
												</div>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
							<template v-slot:footer>
								<div class="pagination">
									<v-pagination
										v-model="page"
										:color="color"
										:length="getPaginationTotal(detail['holdings'].length)"
										:total-visible="$vuetify.breakpoint.xs ? 3: 5"
										circle
										@input="onPaginationInput($event, detail)"
									></v-pagination>
									<div class="pagination-text">show</div>
									<div class="pagination-text-page">{{ countPerpage}}/page</div>
									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on"><Down class="down"/></div>
										</template>
										<v-list>
											<v-list-item-title
												v-for="(pageOption, index) in pageOptions"
												:key="index" class="option-text"
												style="width: 24px"
												@click="onClickOption(pageOption, detail)">
												{{pageOption}}
											</v-list-item-title>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-data-table>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</template>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
		/>
		<HistoryDialog
			v-if="history_visible"
			:visible="history_visible"
			:refId="history_ref_id"
			@input="history_visible = $event"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import ColumnsTable from "@/components/icons/columns_table.vue";
import Calendar from "@/components/icons/calendar.vue";
import Down from '@/components/icons/down';
import KindTreeSelection from "@/components/kinds/kind_tree_selection";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import HistoryDialog from "@/views/desktop/media/radio_holdings/media_holding_history_dialog";

import moment from 'moment';
import config from "@/config.js";
import Decimal from 'decimal.js';

const Table_Headers = [
	{
		text: '',
		showable: true,
		value: 'checkbox',
		is_ckeck: false,
		width: 50
	},
	{
		text: 'Phase',
		showable: true,
		value: 'phase',
		width: 200
	},
	{
		text: 'Media Outlet',
		showable: true,
		value: 'outlet',
		width: 200
	},
	{
		text: 'Kind',
		showable: true,
		value: 'kind',
		width: 200
	},
	{
		text: 'Station',
		showable: true,
		value: 'station_name',
		width: 200
	},
	{
		text: 'Media Reference ID',
		showable: true,
		value: 'media_reference_id',
		width: 200
	},
	{
		text: 'Contract Ref',
		showable: true,
		value: 'contract_ref',
		width: 200
	},
	{
		text: 'Booked Date',
		showable: true,
		value: 'booking_start',
		width: 200
	},
	{
		text: 'Booked Day Flags',
		showable: true,
		value: 'booking_day_flags',
		width: 200
	},
	{
		text: 'Duration',
		showable: true,
		value: 'booking_duration',
		width: 200
	},
	{
		text: 'Start Time',
		showable: true,
		value: 'booking_start_time',
		width: 200
	},
	{
		text: 'End Time',
		showable: true,
		value: 'booking_end_time',
		width: 200
	},
	{
		text: 'Supplier rate',
		showable: true,
		value: 'rate_fc',
		width: 200
	},
	{
		text: 'Bill to client',
		showable: true,
		value: 'value_fc',
		width: 200
	},
	{
		text: 'Program Name',
		showable: true,
		value: 'program_name',
		width: 200
	},
	{
		text: 'Position in Break',
		showable: true,
		value: 'pos_in_break',
		width: 200
	},
	{
		text: 'Material Key Number',
		showable: true,
		value: 'material_key_identifier',
		width: 200
	},
	{
		text: 'Priority Modifier',
		showable: true,
		value: 'priority_modifier',
		width: 200
	},
	// {
	// 	text: 'Custom 1',
	// 	showable: true,
	// 	value: 'custom1',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 2',
	// 	showable: true,
	// 	value: 'custom2',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 3',
	// 	showable: true,
	// 	value: 'custom3',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 4',
	// 	showable: true,
	// 	value: 'custom4',
	// 	width: 200
	// },
	// {
	// 	text: 'Custom 5',
	// 	showable: true,
	// 	value: 'custom5',
	// 	width: 200
	// }
];
const Week_Flag = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const Error_Flag = 'Traffic;';
const Diff_Flag = 'diff_';
const Decimal_Places = 5;

/**
 * 0 = Exception(default)
 * 1 = Accepted
 * 2 = Invoice Query
 * 3 = Ignored
 * 4 = Rejected
 */
const Exception_Status = 0;
const Reject_Status = 4;

/** Markup -> 0, Commission -> 1, Rebate -> 2 */
const Markup_Mode = 0;
const Commission_Mode = 1;
const Rebate_Mode = 2;

const Un_Station_Link_Text = 'There are some bookings where Stations have not been matched.';
const All_Handled_Text = 'All bookings are handled.';
const Un_Matched_Text = 'There are no bookings that match your search filter.';

const Setting_Name = 'RadioException';
const Bulk_Process_Batch_Size = 100;

export default {
	name: 'MediaHoldingException',
	props: {
		color: {
			type: String,
			default: ''
		},
		fileId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.reject_status = Reject_Status;
		this.week_flag = Week_Flag;
		this.diff_flag = Diff_Flag;
		this.kind_params = {
			select_items: true,
			select_kinds: true,
			expense_kinds: true,
			overhead_mode: 0,
			billable_kinds: true,
		};

		return {
			loading: false,
			error_msg: '',
			close_selection: 0,
			user_id: 0,

			headers: Table_Headers,
			exception_holding_num: 0,
			panel_details: [],
			panel_details_orignal: [],

			supplier_items: [],

			filter_menu_visible: false,
			filter_options: {
				new_bookings: true,
				changed_bookings: true,
				material_key: false,
				day_time: false,
				rate_fc: false,
				contract_ref: false,
			},
			is_down: true,
			include_rejected: false,
			columns: Table_Headers.filter(header => { return header.value !== 'checkbox'}),
			select_columns: Table_Headers.filter(header => { return header.value !== 'checkbox'}),

			panel: null,
			system_rate_by_job: {},
			client_by_job: {},
			cost_rate_by_currency_id: {},
			rebate_percentage_cache: null,

			totle_accept_ids: [],
			group_accept_keys: [],
			success_accept_ids: [],
			error_accept_ids: [],

			totle_reject_ids: [],
			success_reject_ids: [],
			success_reject_ids_fake: [],
			error_reject_ids: [],

			page: 1,
			countPerpage: 10,
			pageOptions: config.pageOptions,

			visible_notice: false,
			notice_text: [],
			notice_color: '#00AAFD',
			tid: null,

			history_visible: false,
			history_ref_id: '',
		}
	},
	components: {
		ProgressLinear,
		ColumnsTable,
		Calendar,
		Down,
		KindTreeSelection,
		DialogNotice,
		HistoryDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.getUserId();
		await this.getSettings();
		await this.getSupplierList();

		this.getExceptionJobs(this.fileId, 0, false, 0);
	},
	computed: {
		isFilterDiff() {
			return !this.filter_options.new_bookings
				|| !this.filter_options.changed_bookings
				|| this.filter_options.material_key
				|| this.filter_options.rate_fc
				|| this.filter_options.day_time
				|| this.filter_options.contract_ref;
		},
		isColumnDiff() {
			let is_diff = false;

			if (this.select_columns.length !== this.columns.length) {
				is_diff = true;
			}

			return is_diff;
		}
	},
	watch: {
		async panel() {
			if (this.panel !== undefined && this.panel !== null) {
				const detail = this.panel_details[this.panel];

				if (detail) {
					if (!detail.phase_items || detail.phase_items.length === 0) {
						await this.getPhaseByJob(detail.id);
					}

					this.getExceptionHoldings(this.fileId, detail.id, 0);
			
					/** get currency by job_id => system_rate_by_job */
					if (!this.system_rate_by_job[`${detail.id}`]) {
						await this.getJobCurrency(detail.id);
					}
				}
			}
		},
		select_columns() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const header_obj = Table_Headers.filter(header => { return columns.includes(header.value) });
			
			header_obj.unshift(Table_Headers[0]);
			this.headers = header_obj;
		},
		filter_options: {
			handler(value) {
				if (!value.changed_bookings && (value.material_key || value.day_time || value.rate_fc || value.contract_ref)) {
					this.filter_options.material_key = false;
					this.filter_options.day_time = false;
					this.filter_options.rate_fc = false;
					this.filter_options.contract_ref = false;
					return;
				}

				this.refreshVisibleHoldings();
			},
			deep: true
		}
	},
	methods: {
		formatNumber(rate) {
			const number = Number(rate);
			if (!Number.isFinite(number)) return rate;

			return number.toLocaleString('en-AU', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
		togglePanel(index) {
			this.panel = this.panel === index ? null : index;
			this.panel_details.forEach((detail, detail_index) => {
				detail.down = this.panel === detail_index;
			});
		},
		refreshVisibleHoldings() {
			const panel_details_orignal_obj = this.panel_details_orignal.reduce((obj, detail) => {
				obj[detail.id] = JSON.parse(JSON.stringify(detail.holdings));
				return obj;
			}, {});

			this.panel_details.forEach(detail => {
				if (!detail) return;

				const holdings_orignal = panel_details_orignal_obj[detail.id] || [];
				detail.holdings = this.applyHoldingFilters(holdings_orignal, detail.date);
				detail.check = false;
				detail.active_num = 0;
				detail.reject_num = 0;
				detail.copy_num = 0;
				detail.table_text = detail.holdings.length === 0 ? Un_Matched_Text : '';
			});
		},
		applyHoldingFilters(holdings, date_range = []) {
			let date_filtered_holdings = this.include_rejected 
				? holdings
				: holdings.filter(holding => { return holding.status_reject !== Reject_Status });

			if (date_range && date_range.length === 2) {
				const in_range_holdings = holdings.filter(holding => { return this.isFallRange(holding.booking_start, date_range) });
				const date_parent_media_reference_ids = new Set(in_range_holdings.filter(holding => {
					return holding.parent_id === 0 && holding.has_child === true && holding.media_reference_id;
				}).map(holding => { return holding.media_reference_id }));

				date_filtered_holdings = date_filtered_holdings.filter(holding => {
					return this.isFallRange(holding.booking_start, date_range)
						|| (holding.parent_id !== 0 && holding.has_child === false && date_parent_media_reference_ids.has(holding.media_reference_id));
				});
			}
			const material_key_media_reference_ids = this.filter_options.material_key
				? new Set(date_filtered_holdings.filter(holding => { return holding.diff_material_key_identifier && holding.media_reference_id }).map(holding => { return holding.media_reference_id }))
				: new Set();
			const contract_ref_media_reference_ids = this.filter_options.contract_ref
				? new Set(date_filtered_holdings.filter(holding => { return holding.diff_contract_ref && holding.media_reference_id }).map(holding => { return holding.media_reference_id }))
				: new Set();
			const rate_fc_media_reference_ids = this.filter_options.rate_fc
				? new Set(date_filtered_holdings.filter(holding => { return holding.diff_rate_fc && holding.media_reference_id }).map(holding => { return holding.media_reference_id }))
				: new Set();
			const day_time_media_reference_ids = this.filter_options.day_time
				? new Set(date_filtered_holdings.filter(holding => { return (holding.diff_booking_start || holding.diff_booking_day_flags || holding.diff_booking_duration || holding.diff_booking_start_time || holding.diff_booking_end_time) && holding.media_reference_id }).map(holding => { return holding.media_reference_id }))
				: new Set();

			return date_filtered_holdings.filter(holding => {
				/** New bookings */
				if (holding.parent_id === 0 && holding.has_child === false) {
					return this.filter_options.new_bookings;
				}

				/** Changed bookings */
				if ((holding.parent_id === 0 && holding.has_child === true) || (holding.parent_id !== 0 && holding.has_child === false)) {
					if (holding.status_reject === Reject_Status) {
						return this.include_rejected
					} else {
						if (this.filter_options.material_key || this.filter_options.rate_fc || this.filter_options.day_time || this.filter_options.contract_ref) {
							return (this.filter_options.material_key && holding.diff_material_key_identifier)
								|| (this.filter_options.material_key && holding.parent_id !== 0 && holding.has_child === false && material_key_media_reference_ids.has(holding.media_reference_id))
								|| (this.filter_options.day_time && (holding.diff_booking_start || holding.diff_booking_day_flags || holding.diff_booking_duration || holding.diff_booking_start_time || holding.diff_booking_end_time))
								|| (this.filter_options.day_time && holding.parent_id !== 0 && holding.has_child === false && day_time_media_reference_ids.has(holding.media_reference_id))
								|| (this.filter_options.contract_ref && holding.diff_contract_ref)
								|| (this.filter_options.contract_ref && holding.parent_id !== 0 && holding.has_child === false && contract_ref_media_reference_ids.has(holding.media_reference_id))
								|| (this.filter_options.rate_fc && holding.diff_rate_fc)
								|| (this.filter_options.rate_fc && holding.parent_id !== 0 && holding.has_child === false && rate_fc_media_reference_ids.has(holding.media_reference_id));
						} else {
							if (this.filter_options.changed_bookings) {
								return this.filter_options.changed_bookings;
							}
						}
					}
				}

				return false;
			});
		},
		async getUserId() {
			this.loading = true;

			const url = '/api/user/me';

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getSettings() {
			this.loading = true;

			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);

								const column = windata.column;
								if (column) {
									const columns_orignal = Table_Headers.filter(header => { return header.value !== 'checkbox'});

									const select_columns_view = [];
									columns_orignal.forEach(c => {
										if (column.includes(c.value)) {
											select_columns_view.push(c);
										} 
									});

									this.select_columns = select_columns_view;
								}
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;
						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		async getSupplierList() {
			this.loading = true;

			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						data.forEach(d => {
							if (d.kind) {
								d.kind['display_name'] = d.kind.name;
							}

							d['desc'] = `${d.code} - ${d.display_name}`;
						});
						this.supplier_items = data;

						const currncy_ids = data.map(d => { return d.currency.id });
						const uniqu_currency = [...new Set(currncy_ids)];
						this.getCostCurrencyList(uniqu_currency);						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getExceptionJobs(file_id, job_id, is_calculate_total_num=false, block_btn=0) {
			if (!is_calculate_total_num) {
				this.loading = true;
			}

			let url = `/api/media/media_planning/import_export/${file_id}/get_exception_jobs`;
			
			const params = [];
			params.push("has_invoice=" + false);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			/** block_btn: 0 => no block, 1 => from 'accept btn', 2 => from 'reject btn' */
			if (block_btn > 0) {
				if (block_btn === 1) {
					this.panel_details.forEach(detail => {
						if (job_id !== 0 && detail.id === job_id) {
							this.$set(detail, 'acc_job_flag', true);
						}
					});
				}
				if (block_btn === 2) {
					this.panel_details.forEach(detail => {
						if (job_id !== 0 && detail.id === job_id) {
							this.$set(detail, 'reject_job_flag', true);
						}
					});
				}
			}
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const grouped_jobs = Object.values(data.reduce((jobs_by_id, job) => {
							if (!jobs_by_id[job.joid]) {
								jobs_by_id[job.joid] = {
									...job,
									item_count: Number(job.item_count) || 0,
								};
							} else {
								jobs_by_id[job.joid].item_count += Number(job.item_count) || 0;
							}

							return jobs_by_id;
						}, {})).sort((job_a, job_b) => {
							const job_code_compare = (job_a.jocode || '').localeCompare(job_b.jocode || '');
							if (job_code_compare !== 0) {
								return job_code_compare;
							}

							return (job_a.joshort || '').localeCompare(job_b.joshort || '');
						});
						
						if (is_calculate_total_num) {
							this.exception_holding_num = 0;
							grouped_jobs.forEach((job) => {
								if (job.item_count !== 0) {
									this.exception_holding_num += job.item_count;
								}
							});
						} else {
							grouped_jobs.forEach((job, index) => {
								if (job.item_count !== 0) {
									this.exception_holding_num += job.item_count;

									const date_start = moment(job.date_from).format('YYYY-MM-DD');
									/** Add 6 days to the job end date */
									const date_end = moment(job.date_to).add(6, 'days').format('YYYY-MM-DD');
									
									const obj = {
										id: job.joid,
										down: index === 0,
										menu: false,
										check: false,
										job: job,
										holdings: [],
										date: [date_start, date_end],
										month: date_start.substring(0, 7),
										active_num: 0,
										reject_num: 0,
										copy_num: 0,
										phase: null,
										phase_items: [],
										phase_loading: false,
										accept_loading: false,
										acc_holding_flag: false,
										acc_job_flag: false,
										reject_holding_flag: false,
										reject_job_flag: false,
										table_loading: false,
										table_text: ''
									};

									this.panel_details.push(obj);
									this.panel_details_orignal.push(JSON.parse(JSON.stringify(obj)));
								}
							});

							/** open the first job */
							this.panel = 0;
						}						


						if (!is_calculate_total_num) {
							this.loading = false;
						}
					} else {
						this.error_msg = reason;
						if (!is_calculate_total_num) {
							this.loading = false;
						}
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					if (!is_calculate_total_num) {
						this.loading = false;
					}
				})
				.finally(() => {
					if (block_btn > 0) {
						if (block_btn === 1) {
							this.panel_details.forEach(detail => {
								if (job_id !== 0 && detail.id === job_id) {
									this.$set(detail, 'acc_job_flag', false);
								}
							});
						}
						if (block_btn === 2) {
							this.panel_details.forEach(detail => {
								if (job_id !== 0 && detail.id === job_id) {
									this.$set(detail, 'reject_job_flag', false);
								}
							});
						}
					}
				});
		},
		getExceptionHoldings(file_id, job_id, block_btn=0) {
			this.panel_details.forEach(detail => {
				if (detail.id === job_id) {
					detail.holdings = [];
					detail.table_loading = true;
					detail.table_text = '';
					detail.check = false;
					detail.active_num = 0;
					detail.reject_num = 0;
					detail.copy_num = 0;
				}
			});

			this.panel_details_orignal.forEach(detail => {
				if (detail.id === job_id) {
					detail.holdings = [];
					detail.table_loading = true;
					detail.table_text = '';
					detail.check = false;
					detail.active_num = 0;
					detail.reject_num = 0;
					detail.copy_num = 0;
				}
			});

			let url = `/api/media/media_planning/import_export/${file_id}/exception_holdings`;
			
			const params = [];
			params.push("job_id=" + job_id);
			params.push("has_invoice=" + false);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			/** block_btn: 0 => no block, 1 => from 'accept btn', 2 => from 'reject btn' */
			if (block_btn > 0) {
				if (block_btn === 1) {
					this.panel_details.forEach(detail => {
						if (detail.id === job_id) {
							this.$set(detail, 'acc_holding_flag', true);
						}
					});
				}
				if (block_btn === 2) {
					this.panel_details.forEach(detail => {
						if (detail.id === job_id) {
							this.$set(detail, 'reject_holding_flag', true);
						}
					});
				}
			}
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						if (data[0].items) {
							const supplier_ids_by_station_code = {};
							if (data[0].stations) {
								data[0].stations.forEach(station => {
									if (station.media_supplier_link !== null && station.media_supplier_link.media_supplier !== null) {
										supplier_ids_by_station_code[`${station.code}`] = station.media_supplier_link.media_supplier.id;
									}
								});
							}

							const job_by_product_code = {};
							if (data[0].products) {
								data[0].products.forEach(product => {
									if (product.job_link.job !== null) {
										job_by_product_code[`${product.code}`] = product.job_link.job;
									}
								});
							}

							const network_code = data[0].network_code;

							/** build the structure */
							const holdings_orignal = [];
							const holdings_with_bookings = [];
							const holdings_without_bookings = [];
							data[0].items.forEach(item => {
								if (job_by_product_code[`${item.product}`] && supplier_ids_by_station_code[`${item.station}`]) {
									if (item.bookings === null || (item.bookings && item.bookings.length === 0)) {
										const item_new = this.getRowWithoutBooking(item, network_code);
										item_new['network_code'] = network_code;
										item_new['job_id'] = job_id;
										item_new['status_reject'] = item_new.status;

										const station_obj = data[0].stations.filter(station => { return station.code === item.station });
										item_new['station_name'] = `${station_obj[0].code} - ${station_obj[0].description}`;
										
										/** 
										 * special changed, pass station_link_id, not the station_id
										 * for pub station_id: Option<i32>, different IDs are passed in different scenarios
										*/
										item_new['station_link_id'] = station_obj[0].media_supplier_link ? station_obj[0].media_supplier_link.station_link_id : 0;

										const supplier_id = supplier_ids_by_station_code[`${item.station}`] ? supplier_ids_by_station_code[`${item.station}`] : 0;
										const supplier = supplier_id !== 0 ? (this.supplier_items.filter(supplier => { return supplier.id === supplier_id}))[0] : null;
										item_new['outlet'] = supplier ? supplier : null;
										item_new['original_outlet'] = supplier ? supplier : null;
										item_new['cost_currency'] = supplier ? supplier.currency : null;
										item_new['kind'] = supplier && supplier.kind ? { id: supplier.kind.id, code: supplier.kind.code, display_name: supplier.kind.name } : null;
										item_new['commission_perc'] = supplier ? supplier.commission_perc : 0;

										holdings_without_bookings.push(item_new);
									}

									if (item.bookings && item.bookings.length !== 0) {
										const item_new_arr = this.getRowWithBooking(item, network_code)

										if (item_new_arr.length !== 0) {
											const item_new = item_new_arr[0];
											item_new['job_id'] = job_id;
											item_new['status_reject'] = item_new.status;

											const station_obj = data[0].stations.filter(station => { return station.code === item.station });
											item_new['station_name'] = `${station_obj[0].code} - ${station_obj[0].description}`;
											
											/** 
											 * special changed, pass station_link_id, not the station_id
											 * for pub station_id: Option<i32>, different IDs are passed in different scenarios
											*/
											item_new['station_link_id'] = station_obj[0].media_supplier_link ? station_obj[0].media_supplier_link.station_link_id : 0;


											holdings_with_bookings.push(item_new);

											const item_new_booking = item_new_arr[1];
											item_new_booking['job_id'] = job_id;
											item_new_booking['status_reject'] = item_new.status;
											item_new_booking['station_name'] = `${station_obj[0].code} - ${station_obj[0].description}`;

											/** 
											 * special changed, pass station_link_id, not the station_id
											 * for pub station_id: Option<i32>, different IDs are passed in different scenarios
											*/
											item_new_booking['station_link_id'] = station_obj[0].media_supplier_link ? station_obj[0].media_supplier_link.station_link_id : 0;

											holdings_with_bookings.push(item_new_booking);
										}
									}
								}
							});
							holdings_orignal.push(...holdings_with_bookings, ...holdings_without_bookings);

							/** init phase */
							const detail = this.panel_details.filter(detail => { return detail.id === job_id });
							const phase_items = detail[0].phase_items;
							holdings_orignal.forEach(holding => {
								holding['phase_items'] = phase_items;
								
								if (detail[0].phase) {
									holding['phase'] = detail[0].phase;
								} else {
									if (phase_items.length === 1) {
										holding['phase'] = phase_items[0];
									}
								}
							});

							this.panel_details.forEach(detail => {
								if (detail.id === job_id) {
									const holdings = this.applyHoldingFilters(holdings_orignal, detail.date);
									detail.holdings = JSON.parse(JSON.stringify(holdings));
								}
							});

							this.panel_details_orignal.forEach(detail => {
								if (detail.id === job_id) {
									detail.holdings = JSON.parse(JSON.stringify(holdings_orignal));
								}
							});
						}
						
						this.panel_details.forEach(detail => {
							if (detail.id === job_id) {
								detail.table_loading = false;
								detail.table_text = detail.holdings.length === 0 ? (!data[0].items || (data[0].items && data[0].items.length === 0) ? All_Handled_Text : Un_Station_Link_Text) : '';
							}
						});
					} else {
						this.error_msg = reason;
						this.panel_details.forEach(detail => {
							if (detail.id === job_id) {
								detail.table_loading = false;
							}
						});
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.panel_details.forEach(detail => {
						if (detail.id === job_id) {
							detail.table_loading = false;
						}
					});
				})
				.finally(() => {
					if (block_btn > 0) {
						if (block_btn === 1) {
							this.panel_details.forEach(detail => {
								if (detail.id === job_id) {
									this.$set(detail, 'acc_holding_flag', false);
								}
							});
						}
						if (block_btn === 2) {
							this.panel_details.forEach(detail => {
								if (detail.id === job_id) {
									this.$set(detail, 'reject_holding_flag', false);
								}
							});
						}
					}
				})
			;
		},
		async getPhaseByJob(job_id) {
			this.panel_details.forEach(detail => {
				if (detail.id === job_id) {
					detail.phase_loading = true;
				}
			});

			const url = `/api/jobs/${job_id}/phases`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const phase_items = data.map((d) => { 
							const obj = {
								id: d.id,
								desc: d.display_name,
							};
										
							return obj;
						});

						this.panel_details.forEach(detail => {
							if (detail.id === job_id) {
								detail['phase_items'] = phase_items;
								if (phase_items.length === 1) {
									detail.phase = phase_items[0];
								}

								detail.phase_loading = false;
							}
						});
						
					} else {
						this.error_msg = reason;
						this.panel_details.forEach(detail => {
							if (detail.id === job_id) {
								detail.phase_loading = false;
							}
						});
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.panel_details.forEach(detail => {
						if (detail.id === job_id) {
							detail.phase_loading = false;
						}
					});
				});
		},
		async getJobCurrency(job_id) {
			const url = `/api/jobs/${job_id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.client_by_job[`${job_id}`] = data.client;

						this.getExratesForDate(data.currency)
							.then(exchange_rates => {
								const currency_obj = JSON.parse(JSON.stringify(data.currency));
								currency_obj['rate'] = Number(exchange_rates.rate);
								
								this.system_rate_by_job[`${job_id}`] = currency_obj;
							})
							.catch((reason) => {
								this.error_msg = reason;
							});
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getRowWithoutBooking(item) {
			const new_item = JSON.parse(JSON.stringify(item));

			new_item['checkbox'] = false;
			new_item['phase'] = null;
			new_item['original_phase'] = null;
			new_item['phase_items'] = [];
			new_item['media_reference_id'] = item.media_ref;
			new_item['contract_ref'] = item.contract;
			new_item['booking_day_flags'] = item.day_flags.length !== 0 ? item.day_flags.split("") : [];
			new_item['booking_start'] = this.calculateBookedDate(item.booked_date, item.day_flags);
			new_item['booking_end'] = this.calculateBookedEnd(item.booked_date, item.day_flags);
			new_item['booking_duration'] = `${item.duration} sec`;
			new_item['booking_start_time'] = item.start_time.length === 0 ? '' : `${item.start_time.substring(0,2)}:${item.start_time.substring(2,4)}`;
			new_item['booking_end_time'] = item.end_time.length === 0 ? '' : `${item.end_time.substring(0,2)}:${item.end_time.substring(2,4)}`;
			new_item['value_currency'] = null;
			new_item['rate_fc'] = item.rate;
			new_item['value_fc'] = 0; 
			new_item['program_name'] = item.program;
			new_item['pos_in_break'] = item.pos_in_break;
			new_item['material_key_identifier'] = item.key_number;
			new_item['priority_modifier'] = item.prority_modifier;
			// new_item['custom1'] = '';
			// new_item['custom2'] = '';
			// new_item['custom3'] = '';
			// new_item['custom4'] = '';
			// new_item['custom5'] = '';
			new_item['parent_id'] = 0;
			new_item['has_child'] = false;
			new_item['is_last'] = true;

			new_item[`${this.diff_flag}network_code`] = false;
			new_item[`${this.diff_flag}media_reference_id`] = false;
			new_item[`${this.diff_flag}contract_ref`] = false;
			new_item[`${this.diff_flag}booking_day_flags`] = false;
			new_item[`${this.diff_flag}booking_start`] = false;
			new_item[`${this.diff_flag}duration`] = false;
			new_item[`${this.diff_flag}booking_start_time`] = false;
			new_item[`${this.diff_flag}booking_end_time`] = false;
			new_item[`${this.diff_flag}rate_fc`] = false;
			new_item[`${this.diff_flag}program_name`] = false;
			new_item[`${this.diff_flag}material_key_identifier`] = false;
			new_item[`${this.diff_flag}priority_modifier`] = false;

			return new_item;
		},
		getRowWithBooking(item, network_code) {
			let is_exception = false;

			/** compare the diff */
			const diff_item = {};

			const booking = item.bookings[0];
			diff_item[`${this.diff_flag}network_code`] = booking.network_code !== network_code ? true : false;
			diff_item[`${this.diff_flag}media_reference_id`] = booking.media_reference_id !== item.media_ref ? true : false;
			diff_item[`${this.diff_flag}contract_ref`] = booking.contract_ref !== item.contract ? true : false;
			diff_item[`${this.diff_flag}booking_day_flags`] = booking.booking_day_flags !== item.day_flags ? true : false;

			const item_booked_date = this.calculateBookedDate(item.booked_date, item.day_flags);
			const booking_booked_date = this.calculateBookedDate(booking.booked_date, booking.booking_day_flags);	
			diff_item[`${this.diff_flag}booking_start`] = booking.booked_date === null || booking.booked_date.length === 0 || item.booked_date === null || item.booked_date.length === 0 || item_booked_date !== booking_booked_date ? true : false;
			
			diff_item[`${this.diff_flag}duration`] = booking.booking_duration !== item.duration ? true : false;
			diff_item[`${this.diff_flag}booking_start_time`] = booking.booking_start_time !== item.start_time ? true : false;
			diff_item[`${this.diff_flag}booking_end_time`] = booking.booking_end_time !== item.end_time ? true : false;
			diff_item[`${this.diff_flag}rate_fc`] = booking.rate_fc !== item.rate ? true : false;
			diff_item[`${this.diff_flag}program_name`] = booking.program_name !== item.program ? true : false;
			diff_item[`${this.diff_flag}pos_in_break`] = booking.pos_in_break !== item.pos_in_break ? true : false;
			diff_item[`${this.diff_flag}material_key_identifier`] = booking.material_key_identifier !== item.key_number ? true : false;
			diff_item[`${this.diff_flag}priority_modifier`] = booking.priority_modifier !== item.prority_modifier ? true : false;
			
			is_exception = Object.values(diff_item).some(item => { return item === true });
		
			if (is_exception && !booking.has_cinv) {
				const new_item = JSON.parse(JSON.stringify(item));

				new_item['network_code'] = network_code;
				new_item['checkbox'] = false;

				const phase_obj = { id: booking.phase_id, desc : booking.phase_desc };
				new_item['phase'] = phase_obj;
				new_item['original_phase'] = phase_obj;
				new_item['phase_items'] = [phase_obj];

				const supplier_arr = this.supplier_items.filter(supplier => { return supplier.id === booking.supplier.id });
				new_item['outlet'] = supplier_arr[0];
				new_item['original_outlet'] = supplier_arr[0];
				new_item['commission_perc'] = supplier_arr[0].commission_perc;

				new_item['kind'] = { id: booking.kind.id, code: booking.kind.code, display_name: booking.kind.name };
				new_item['media_reference_id'] = item.media_ref;
				new_item['contract_ref'] = item.contract;
				new_item['booking_day_flags'] = item.day_flags.length !== 0 ? item.day_flags.split("") : [];
				new_item['booking_start'] = this.calculateBookedDate(item.booked_date, item.day_flags);
				new_item['booking_end'] = this.calculateBookedEnd(item.booked_date, item.day_flags);
				new_item['booking_duration'] = `${item.duration} sec`;
				new_item['booking_start_time'] = item.start_time.length === 0 ? '' : `${item.start_time.substring(0,2)}:${item.start_time.substring(2,4)}`;
				new_item['booking_end_time'] = item.end_time.length === 0 ? '' : `${item.end_time.substring(0,2)}:${item.end_time.substring(2,4)}`;
				new_item['cost_currency'] = booking.cost_currency;
				new_item['value_currency'] = booking.value_currency;
				new_item['rate_fc'] = item.rate;
				new_item['value_fc'] = booking.value_fc; 
				new_item['program_name'] = item.program;
				new_item['pos_in_break'] = item.pos_in_break;
				new_item['material_key_identifier'] = item.key_number;
				new_item['priority_modifier'] = item.prority_modifier;
				// new_item['custom1'] = '';
				// new_item['custom2'] = '';
				// new_item['custom3'] = '';
				// new_item['custom4'] = '';
				// new_item['custom5'] = '';
				new_item['parent_id'] = 0;
				new_item['has_child'] = true;
				new_item['is_last'] = false;
				
				for (const [key, value] of Object.entries(diff_item)) {
					new_item[`${key}`] = value;
				}

				const new_booking = JSON.parse(JSON.stringify(booking));
				new_booking['checkbox'] = false;
				new_booking['phase'] = phase_obj;
				new_booking['original_phase'] = phase_obj;
				new_booking['outlet'] = supplier_arr[0];
				new_booking['original_outlet'] = supplier_arr[0];
				new_booking['kind'] = { id: booking.kind.id, code: booking.kind.code, display_name: booking.kind.name };

				new_booking['network_code'] = booking.network_code;
				new_booking['media_reference_id'] = booking.media_reference_id;
				new_booking['contract_ref'] = booking.contract_ref;
				new_booking['booking_day_flags'] = booking.booking_day_flags.split("");
				new_booking['booking_start'] = this.calculateBookedDate(booking.booked_date, booking.booking_day_flags);
				new_booking['booking_end'] = this.calculateBookedEnd(booking.booked_date, booking.booking_day_flags);
				new_booking['booking_duration'] = `${booking.booking_duration} sec`;
				new_booking['booking_start_time'] = booking.booking_start_time.length !== 0 ? `${booking.booking_start_time.substring(0,2)}:${booking.booking_start_time.substring(2,4)}` : '';
				new_booking['booking_end_time'] = booking.booking_end_time.length !== 0 ? `${booking.booking_end_time.substring(0,2)}:${booking.booking_end_time.substring(2,4)}` : '';
				new_booking['rate_fc'] = booking.rate_fc;
				new_booking['value_fc'] = booking.value_fc;
				new_booking['program_name'] = booking.program_name;
				new_booking['material_key_identifier'] = item.key_number;
				new_booking['pos_in_break'] = booking.pos_in_break;
				new_booking['material_key_identifier'] = booking.material_key_identifier;
				new_booking['priority_modifier'] = booking.prority_modifier;
				// new_booking['custom1'] = '';
				// new_booking['custom2'] = '';
				// new_booking['custom3'] = '';
				// new_booking['custom4'] = '';
				// new_booking['custom5'] = '';
				new_booking['parent_id'] = item.id;
				new_booking['has_child'] = false;
				new_booking['is_last'] = true;

				return [new_item, new_booking];
			} else {
				return [];
			}
		},
		getRowStyle(item_obj) {
			let style_str = '';

			if (item_obj.parent_id === 0) {
				if (item_obj.has_child) {
					style_str = 'border-bottom: thin solid transparent'
				} else {
					style_str = ''
				}
			} else {
				if (item_obj.is_last) {
					style_str = '';
				} else {
					style_str = 'border-bottom: thin solid transparent'
				}
			}

			return style_str
		},
		getCostCurrencyList(currency_ids) {
			for (let index = 0; index < currency_ids.length; index++) {
				const currency_id = currency_ids[index];

				const currncy_obj = { id: currency_id }
				this.getExratesForDate(currncy_obj)
					.then(exchange_rates => {								
						this.cost_rate_by_currency_id[`${currency_id}`] = Number(exchange_rates.rate);
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}
		},
		getExratesForDate(currency) {
			const date = moment().format('YYYY-MM-DD');
			const url = `/api/config/currency/${currency.id}/exchange_rates/${date}`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		getRebatePercentage(job_id, client_id, kind_id) {
			let url = `/api/config/rates/rebate_percentage`;

			const params = [];
			params.push("job_id=" + job_id);
			params.push("client_id=" + client_id);
			
			if (kind_id) {
				params.push("kind_id=" + kind_id);
			}

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		async getCachedRebatePercentage(job_id, client_id, kind_id) {
			const cache = this.rebate_percentage_cache;
			const has_same_ids = cache
				&& cache.job_id === job_id
				&& cache.client_id === client_id
				&& cache.kind_id === kind_id;

			if (has_same_ids) {
				return cache.rebate_perc;
			}

			const rebate_perc = Number(await this.getRebatePercentage(job_id, client_id, kind_id));
			this.rebate_percentage_cache = {
				job_id: job_id,
				client_id: client_id,
				kind_id: kind_id,
				rebate_perc: rebate_perc
			};

			return rebate_perc;
		},
		getMarkup(job_id, supplier_id, kind_id) {
			let url = `/api/config/rates/markup`;

			const params = [];
			params.push("job_id=" + job_id);
			params.push("supplier_id=" + supplier_id);
			if (kind_id) {
				params.push("kind_id=" + kind_id);
			}

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		onIncludeRejectedCheckBox() {
			const panel_details_orignal_obj = this.panel_details_orignal.reduce((obj, detail) => {
				obj[detail.id] = JSON.parse(JSON.stringify(detail.holdings));
				return obj;
			}, {});

			this.panel_details.forEach(detail => {
				if (detail) {
					const holdings_orignal = panel_details_orignal_obj[detail.id];
					detail.holdings = this.applyHoldingFilters(holdings_orignal, detail.date);
					detail.table_text = this.isFilterDiff && detail.holdings.length === 0 ? Un_Matched_Text : '';
				}
			});		
		},
		onSelectColumn() {
			const columns = this.select_columns.map(columns => { return columns.value });
			const win_setup_obj = {
				column: columns
			};
			const win_setup = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup).catch((e) => {
				this.error_msg = e;
			});
		},
		onPhaseChange(phase, detail) {
			const holding_ids = detail.holdings.map(holding => { return holding.id });

			detail.holdings.forEach(holding => {
				if (holding.phase === null || holding.phase === undefined) {
					holding['phase'] = phase;
					holding['phase_items'] = [phase];
				}				
			});
			this.panel_details_orignal.forEach(original_detail => {
				if (original_detail.id === detail.id) {
					original_detail['phase'] = phase;
					original_detail.holdings.forEach(holding => {
						if (holding_ids.includes(holding.id)) {
							if (holding.phase === null || holding.phase === undefined) {
								holding['phase'] = phase;
								holding['phase_items'] = [phase];
							}
						}
					});
				}
			});

			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });

			const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.active_num = active_item.length;

			const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.reject_num = reject_item.length;

			const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
			detail.copy_num = copy_item.length;
		},
		onTablePhaseChange(phase, detail) {
			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
					
			const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.active_num = active_item.length;

			const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.reject_num = reject_item.length;

			const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
			detail.copy_num = copy_item.length;
		},
		async onAccept(detail) {
			const accept_holdings = detail.holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.checkbox === true && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			if (accept_holdings.length === 0) return;
			this.$set(detail, 'accept_loading', true);

			/** init accept_ids */
			const totle_accept_ids_tmp = [];
			accept_holdings.forEach(holding => { totle_accept_ids_tmp.push(holding.id) });
			this.totle_accept_ids = totle_accept_ids_tmp;
			this.group_accept_keys = [];
			this.success_accept_ids = [];
			this.error_accept_ids = [];

			this.notice_text = [];
			this.notice_text = [`Accept/Create Bookings: Pre-processing`, `Error: ${this.error_accept_ids.length}`];
			this.visible_notice = true;
			
			const grouped_accept_holdings = Object.values(accept_holdings.reduce((groups, holding) => {
				const group_key = `${holding.outlet.id}_${holding.booking_start}`;

				if (!groups[group_key]) {
					groups[group_key] = [];
				}

				groups[group_key].push(holding);

				return groups;
			}, {}));
			/** The item count in the API request */
			this.group_accept_keys = grouped_accept_holdings;

			const params_arr = [];
			for (let index = 0; index < grouped_accept_holdings.length; index++) {
				const group_holdings = grouped_accept_holdings[index];
				await this.getParamsByGroup(group_holdings).then(val => {
					params_arr.push(val);
				});
				;
			}

			this.notice_text = [];
			this.notice_text = [`Accept/Create Bookings: Processing`, `Error: ${this.error_accept_ids.length}`];

			this.bulkProcessMediaPlan(params_arr)
				.then((val) => {
					this.success_accept_ids = val.processed_ids;
					const error_count = Math.max(0, this.group_accept_keys.length - this.success_accept_ids.length);
					this.error_accept_ids = this.group_accept_keys.slice(0, error_count);
					
					this.notice_text = [];
					this.notice_text = [`Accept/Create Bookings: Completed`, `Error: ${this.error_accept_ids.length}`];

					this.checkFinish(detail.id);
					this.$set(detail, 'accept_loading', false);
				})
				.catch((reason) => {
					this.error_msg = reason;					
					this.success_accept_ids = [];
					
					this.notice_text = [];
					this.notice_text = [`Accept/Create Bookings: ${this.success_accept_ids.length} / ${this.totle_accept_ids.length}`, `Error: ${this.totle_accept_ids.length}`];

					this.checkFinish(detail.id);
					this.$set(detail, 'accept_loading', false);
				});		
		},
		async onReject(detail) {
			const reject_holdings = detail.holdings.filter(holding => { return holding.parent_id === 0 && holding.checkbox === true && holding.status_reject !== Reject_Status });

			if (reject_holdings.length === 0) return;

			/** init accept_ids */
			const totle_reject_ids_tmp = [];
			reject_holdings.forEach(holding => { totle_reject_ids_tmp.push(holding.id) });
			this.totle_reject_ids = totle_reject_ids_tmp;
			this.success_reject_ids = [];
			this.success_reject_ids_fake = [];
			this.error_reject_ids = [];

			this.notice_text = [`Reject Bookings: ${this.success_reject_ids_fake.length} / ${this.totle_reject_ids.length}`, `Error: ${this.error_reject_ids.length}`];
			this.visible_notice = true;

			const params_arr = [];
			for (let index = 0; index < reject_holdings.length; index++) {
				const holding = reject_holdings[index];
				const params = {
					id: holding.id,
					status: Reject_Status
				};
				params_arr.push(params)
			}

			/** fake progress */
			for (let index = 0; index < reject_holdings.length - 1; index++) {
				const fake_holding = reject_holdings[index];
				setTimeout(() => { 
					this.success_reject_ids_fake.push(fake_holding.id);
					this.notice_text = [];
					this.notice_text = [`Reject Bookings: ${this.success_reject_ids_fake.length} / ${this.totle_reject_ids.length}`, `Error: ${this.error_reject_ids.length}`];
				}, 300);
			}

			this.bulkSetItemStatus(params_arr)
				.then(() => {
					const reject_holding_ids = reject_holdings.map(holding => { return holding.id });

					this.success_reject_ids = reject_holding_ids;
					this.success_reject_ids_fake = reject_holding_ids;
					this.error_reject_ids = [];
					
					this.notice_text = [];
					this.notice_text = [`Reject Bookings: ${this.success_reject_ids_fake.length} / ${this.totle_reject_ids.length}`, `Error: ${this.error_reject_ids.length}`];

					this.checkRejectFinish(detail.id);
				})
				.catch((reason) => {
					this.error_msg = reason;

					const reject_holding_ids = reject_holdings.map(holding => { return holding.id });					
					this.success_reject_ids = [];
					this.success_reject_ids_fake = [];
					this.error_reject_ids = reject_holding_ids;
					
					this.notice_text = [];
					this.notice_text = [`Reject Bookings: ${this.success_reject_ids_fake.length} / ${this.totle_reject_ids.length}`, `Error: ${this.error_reject_ids.length}`];

					this.checkRejectFinish(detail.id);
				});
		},
		onCopySelected() {
			let holding_arr = [];

			this.panel_details.forEach(detail => {
				holding_arr = [...holding_arr, ...detail.holdings];
			});

			const active_items = holding_arr.filter(holding => { return holding.checkbox === true && holding.parent_id === 0 });
			let str_arr = [];

			const next_line_print = ['br'];
			const top_str = `Kindly assist with resolving the following bookings where our records differ from the latest file (date of file):`;
			str_arr.push(top_str);
			str_arr = [...str_arr, ...next_line_print];

			active_items.forEach(item => {
				const booking = holding_arr.filter(holding => { return holding.parent_id === item.id });
				const booking_item = booking[0];

				const print_str = `Media Ref ID: ${item.media_reference_id}`;
				str_arr.push(print_str);

				let date_print = [];
				let flag_print = [];
				let start_print = [];
				let end_print = [];
				let rate_print = [];
						
				for (const [key, value] of Object.entries(item)) {
					if (booking_item) {
						if (key.startsWith(Diff_Flag)) {
							const name = key.split(Diff_Flag);
							const print_key = name[1];

							if (value === true) {
								if (print_key === 'booking_start') {
									const current_date = `Date(Radio holdings data): ${moment(item[`${print_key}`]).format('DD MMM YYYY')}`;
									const lasr_date = `Date(Our records): ${moment(booking_item[`${print_key}`]).format('DD MMM YYYY')}`;
									date_print = [current_date, lasr_date];
								} 

								if (print_key === 'booking_day_flags') {
									const current_day_flag = `Booked day flags (Radio holdings data): ${item[`${print_key}`].join('')}`;
									const last_day_flag = `Booked day flags (Our records): ${booking_item[`${print_key}`].join('')}`;
									flag_print = [current_day_flag, last_day_flag];
								}

								if (print_key === 'booking_start_time') {
									const current_date = `Start time (Radio holdings data):  ${item[`${print_key}`]}`;
									const lasr_date = `Start time (Our records): ${booking_item[`${print_key}`]}`;
									start_print = [current_date, lasr_date];
								}

								if (print_key === 'booking_end_time') {
									const current_date = `End time (Radio holdings data):  ${item[`${print_key}`]}`;
									const lasr_date = `End time (Our records): ${booking_item[`${print_key}`]}`;
									end_print = [current_date, lasr_date];
								}

								if (print_key === 'rate_fc') {
									const current_rate = `Invoiced (Radio holdings data): ${item.cost_currency ? item.cost_currency.symbol : '$'} ${item[`${print_key}`]}`;
									const lasr_rate = `Invoiced (Our records): ${item.cost_currency ? item.cost_currency.symbol : '$'} ${booking_item[`${print_key}`]}`;
									rate_print = [current_rate, lasr_rate];
								}
							} else {
								if (print_key === 'booking_start') {
									date_print = [`Date: ${moment(item[`${print_key}`]).format('DD MMM YYYY')}`];
								}
							}
						}
					} else {
						if (key === 'booking_start') {
							const current_date = `Date: ${moment(item[`${key}`]).format('DD MMM YYYY')}`;
							date_print = [current_date];
						} 
					
						if (key === 'booking_day_flags') {
							const current_day_flag = `Booked day flags: ${item[`${key}`].join('')}`;
							flag_print = [current_day_flag];
						}

						if (key === 'booking_start_time') {
							const current_date = `Start time:  ${item[`${key}`]}`;
							start_print = [current_date];
						}

						if (key === 'booking_end_time') {
							const current_date = `End time:  ${item[`${key}`]}`;
							end_print = [current_date];
						}

						if (key === 'rate_fc') {
							const current_rate = `Invoiced: ${item.cost_currency ? item.cost_currency.symbol : '$'} ${item[`${key}`]}`;
							rate_print = [current_rate];
						}
					}
				}
				str_arr = [...str_arr, ...date_print, ...flag_print, ...start_print, ...end_print, ...rate_print, ...next_line_print];
			})
			
			this.copyCustomFormat(str_arr);
		},
		copyCustomFormat(str_arr) {
			let textContent = '';

			str_arr.forEach(str => {
				if (str === 'br') {
					textContent += `\r\n`;
				} else {
					textContent += `${str}\r\n`;
				}
			});
			
			/** works in many older browsers */
			const textarea = document.createElement("textarea");
			textarea.value = textContent;
			textarea.style.position = "fixed";
			document.body.appendChild(textarea);
			textarea.focus();
			textarea.select();

			try {
				document.execCommand("copy");
				const text = 'Copied successfully.';
				this.notice_text.push(text);
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);
			} catch (err) {
				const text = 'Copied failed.';

				this.notice_text.push(text);
				this.visible_notice = true;
				this.tid = setTimeout(this._close, 2000);
			}

			document.body.removeChild(textarea);

			/** This feature is available only in secure contexts (HTTPS), in some or all supporting browsers. */
			/**
					try {
						await navigator.clipboard.writeText(textContent);

						const text = 'Copied successfully.';
						this.notice_text.push(text);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

					} catch (err) {
						const text = 'Copied failed.';

						this.notice_text.push(text);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					}
			 */
		},
		onDateChange(value_arr, id) {
			if (value_arr.length !== 2) return;
			value_arr.sort();
			const date_range = value_arr;

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(holdings, date_range);

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastWeek(id) {
			const last_week_start = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD');
			const last_week_end = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
			const date_range = [last_week_start, last_week_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(holdings, date_range);

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onLastMonth(id) {
			const last_month_start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
			const last_month_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
			const date_range = [last_month_start, last_month_end];

			const current_panel_detail = this.panel_details_orignal.filter(detail => { return detail.id === id});
			const holdings = JSON.parse(JSON.stringify(current_panel_detail[0].holdings));

			const holdings_filter = this.applyHoldingFilters(holdings, date_range);

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail['holdings'] = holdings_filter;
					detail['date'] = date_range;
					detail['menu'] = false;
					detail[`month`] = date_range[0].substring(0, 7);
				}
			});
		},
		onCheckBoxAll(is_check, id) {
			const start_index = (this.page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;

			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					detail.holdings.slice(start_index, end_index).forEach(hold => {
						hold.checkbox = is_check;
					});

					const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });
					
					const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
					detail.active_num = active_item.length;

					const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
					detail.reject_num = reject_item.length;

					const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
					detail.copy_num = copy_item.length;
				}
			});
		},
		onCheckBox(id) {
			this.panel_details.forEach(detail => {
				if (detail.id === id) {
					const start_index = (this.page - 1) * this.countPerpage;
					const end_index = start_index + this.countPerpage;
					const current_page_holdings = detail.holdings.slice(start_index, end_index);
					const current_page_holdings_filter = current_page_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
					const selected_holdings = current_page_holdings.filter(holding => { return holding.checkbox === true });
					detail.check = current_page_holdings_filter.length !== 0 && selected_holdings.length === current_page_holdings_filter.length;

					const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });

					const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
					detail.active_num = active_item.length;

					const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
					detail.reject_num = reject_item.length;

					const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
					detail.copy_num = copy_item.length;
				}
			});
		},
		onUndo(holding, detail) {
			this.rejectBooking(holding.id, Exception_Status)
				.then(() => {
					this.notice_text = [];
					this.notice_text = [`Undo reject successful.`];
					this.visible_notice = true;

					this.tid = setTimeout(this._close, 2000);

					this.getExceptionHoldings(this.fileId, detail.id, 0);
					this.getExceptionJobs(this.fileId, 0, true, 0);
				})
				.catch((reason) => {
					this.notice_text = [];
					this.notice_text = [`Undo reject failed`, `Error: ${reason}`];
					this.visible_notice = true;

					this.tid = setTimeout(this._close, 2000);
				});	
		},
		onOutletChange(supplier, holding) {
			if (supplier) {
				holding.commission_perc = supplier.commission_perc;

				if (supplier.kind) {
					const kind_obj = {
						id: supplier.kind.id,
						code: supplier.kind.code,
						display_name: supplier.kind.display_name
					};
				
					holding.kind = kind_obj;
				} else {
					holding.kind = null;
				}

				holding.cost_currency = supplier.currency;
			} else {
				holding.kind = null;
			}
		},
		onKindChange(kind, holding) {
			if (kind) {
				const kind_obj = {
					id: kind.id,
					code: kind.code,
					display_name: kind.display_name,
				};

				holding.kind = kind_obj;
			}
		},
		onHistoryClick(item) {
			this.history_ref_id = item;
			this.history_visible = true;
		},
		formatDateRange(date) {
			return `${moment(date[0]).format('DD MMM')} - ${moment(date[1]).format('DD MMM')}`;
		},
		formatDate(date_str) {
			return `${moment(date_str).format('DD MMM YYYY')}`;
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.headers.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`] !== null || item_obj[`${header}`] !== undefined ? item_obj[`${header}`] : '';
			});

			return filter_obj;
		},
		async getParamsByGroup(holdings) {
			const holdings_with_booking = holdings.filter(holding => { return holding.has_child });
			const media_holding = holdings_with_booking.length !== 0 ? holdings_with_booking[0] : holdings[0];
			const plan_id = holdings_with_booking.length !== 0 ? media_holding.bookings[0].plan_id : 0;

			const params = {};

			params['id'] = plan_id
			params['phase_id'] = media_holding.phase.id;
			params['supplier_id'] = media_holding.outlet.id;
			params['kind_id'] = media_holding.kind.id;
			params['cost_curr_id'] = media_holding.cost_currency.id;
			params['value_curr_id'] = this.system_rate_by_job[`${media_holding.job_id}`].id;
			params['description'] = media_holding.program_name;
			params['target'] = '';
			params['notes'] = '';
			params['do_print'] = true;
			params['exrate_margin_perc'] = 0;
			
			const bookings = [];
			for (let index = 0; index < holdings.length; index++) {
				const holding = holdings[index];
				if (holding.has_child) {
					await this.getBookingParamsForUpdate(holding, plan_id).then(val => {
						bookings.push(val);
					});
				} else {
					await this.getBookingParamsForCreate(holding).then(val => {
						bookings.push(val);
					});
				}
			}

			params['bookings'] = bookings;

			return params;
		},
		async getBookingParamsForCreate(holding) {
			const booking_obj = {};

			booking_obj['booking_type'] = 1; // 0-traditional booking, 1- radio holdings
			booking_obj['plan_id'] = 0;
			booking_obj['booking_start'] = holding.booking_start;
			booking_obj['booking_end'] = holding.booking_end;
			booking_obj['units'] = 1;
			booking_obj['status'] = 1; // Planned
			booking_obj['is_foc'] = false;
			booking_obj['donotbill'] = false;
			booking_obj['is_deleted'] = false;
			booking_obj['is_vouchered'] = false;
			booking_obj['comm_perc'] = holding.commission_perc;
			
			let rebate_perc = 0;
			await this.getCachedRebatePercentage(holding.job_id, this.client_by_job[`${holding.job_id}`].id, holding.kind.id)
				.then(val => {		
					rebate_perc = val;
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
			booking_obj['booking_mode'] = rebate_perc === 0 ? (holding.commission_perc === 0 ? Markup_Mode : Commission_Mode) : Rebate_Mode;

			booking_obj['exrate_cost'] = Number(this.cost_rate_by_currency_id[`${holding.cost_currency.id}`]);
			booking_obj['exrate_value'] = Number(this.system_rate_by_job[`${holding.job_id}`].rate);
			booking_obj['exrate_div'] = Number(this.system_rate_by_job[`${holding.job_id}`].rate);

			let make_up_perc = 0;
			if (booking_obj.booking_mode === Markup_Mode) {
				await this.getMarkup(holding.job_id, holding.outlet.id, holding.kind.id)
					.then(val => {								
						make_up_perc = Number(val);
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}

			/**
			 * if booking_mode = Rebate_Mode, markup_perc = rebate_perc;
			 * if booking_mode != Rebate_Mode, markup_perc = markup_perc(0 or make_up percentage);
			 */
			const markup_perc = Number(make_up_perc * 100).toFixed(2);
			booking_obj['markup_perc'] = rebate_perc !== 0 ? rebate_perc : Number(markup_perc);

			let cal_obj = null;
			holding['units'] = 1;
			holding['booking_mode'] = rebate_perc === 0 ? (holding.commission_perc === 0 ? Markup_Mode : Commission_Mode) : Rebate_Mode;
			await this.calculateBooking(holding, make_up_perc, rebate_perc).then(val => {
				cal_obj = val;
			});
			booking_obj['rate_fc'] = cal_obj.supplier_rate;
			booking_obj['rate_div'] = cal_obj.supplier_rate;
			booking_obj['amount_fc'] = cal_obj.supplier_amount;
			booking_obj['amount_div'] = cal_obj.supplier_amount;
			booking_obj['commamount_fc'] = cal_obj.commission_amount;
			booking_obj['commamount_div'] = cal_obj.commission_amount;
			booking_obj['net_fc'] = cal_obj.net_schedule;
			booking_obj['net_div'] = cal_obj.net_schedule;
			booking_obj['margin_fc'] = cal_obj.margin_amount_schedule;
			booking_obj['margin_div'] = cal_obj.margin_amount_schedule;
			booking_obj['markupamount_fc'] = cal_obj.make_up_amount;
			booking_obj['markupamount_div'] = cal_obj.make_up_amount;
			booking_obj['value_fc'] = cal_obj.bill;
			booking_obj['value_div'] = cal_obj.bill;			
			
			/** radio holidings */
			booking_obj['pos_in_break'] = holding.pos_in_break;
			booking_obj['mat_key_identifier'] = holding.key_number;
			booking_obj['priority_modifier'] = holding.priority_modifier;
			booking_obj['med_ref_id'] = holding.media_ref;
			booking_obj['booked_date'] = holding.booked_date;
			booking_obj['booking_day_flags'] = holding.day_flags;
			booking_obj['booking_start_time'] = holding.start_time;
			booking_obj['booking_end_time'] = holding.end_time;
			booking_obj['prog_name'] = holding.program_name; 
			booking_obj['contract_ref'] = holding.contract_ref;
			booking_obj['network_code'] = holding.network_code;
			booking_obj['booking_duration'] = holding.duration;
			booking_obj['station_id'] = holding.station_link_id;
			
			return booking_obj
		},
		async getBookingParamsForUpdate(holding, plan_id) {
			const booking_obj = {};

			booking_obj['booking_type'] = 1; // 0-traditional booking, 1- radio holdings
			booking_obj['plan_id'] = plan_id;
			booking_obj['id'] = holding.bookings[0].id;
			booking_obj['booking_start'] = holding.booking_start;
			booking_obj['booking_end'] = holding.booking_start;
			booking_obj['units'] = holding.bookings[0].units;
			booking_obj['status'] = holding.bookings[0].status;
			booking_obj['is_foc'] = false;
			booking_obj['donotbill'] = false;
			booking_obj['is_deleted'] = false;
			booking_obj['is_vouchered'] = false;
			booking_obj['comm_perc'] = holding.commission_perc;

			let rebate_perc = 0;
			await this.getCachedRebatePercentage(holding.job_id, this.client_by_job[`${holding.job_id}`].id, holding.kind.id)
				.then(val => {		
					rebate_perc = val;
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
			booking_obj['booking_mode'] = rebate_perc === 0 ? (holding.commission_perc === 0 ? Markup_Mode : Commission_Mode) : Rebate_Mode;

			booking_obj['exrate_cost'] = Number(this.cost_rate_by_currency_id[`${holding.cost_currency.id}`]);
			booking_obj['exrate_value'] = Number(this.system_rate_by_job[`${holding.job_id}`].rate);
			booking_obj['exrate_div'] = Number(this.system_rate_by_job[`${holding.job_id}`].rate);

			let make_up_perc = 0;
			if (booking_obj.booking_mode === Markup_Mode) {
				await this.getMarkup(holding.job_id, holding.outlet.id, holding.kind.id)
					.then(val => {	
						make_up_perc = Number(val);
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}
			/**
			 * if booking_mode = Rebate_Mode, markup_perc = rebate_perc;
			 * if booking_mode != Rebate_Mode, markup_perc = markup_perc(0 or make_up percentage);
			 */
			const markup_perc = Number(make_up_perc * 100).toFixed(2);
			booking_obj['markup_perc'] = rebate_perc !== 0 ? rebate_perc : Number(markup_perc);

			let cal_obj = null;
			holding['units'] = 1;
			holding['booking_mode'] = rebate_perc === 0 ? (holding.commission_perc === 0 ? Markup_Mode : Commission_Mode) : Rebate_Mode;

			await this.calculateBooking(holding, make_up_perc, rebate_perc).then(val => {
				cal_obj = val;
			});

			booking_obj['rate_fc'] = cal_obj.supplier_rate;
			booking_obj['rate_div'] = cal_obj.supplier_rate;
			booking_obj['amount_fc'] = cal_obj.supplier_amount;
			booking_obj['amount_div'] = cal_obj.supplier_amount;
			booking_obj['commamount_fc'] = cal_obj.commission_amount;
			booking_obj['commamount_div'] = cal_obj.commission_amount;
			booking_obj['net_fc'] = cal_obj.net_schedule;
			booking_obj['net_div'] = cal_obj.net_schedule;
			booking_obj['margin_fc'] = cal_obj.margin_amount_schedule;
			booking_obj['margin_div'] = cal_obj.margin_amount_schedule;
			booking_obj['markupamount_fc'] = cal_obj.make_up_amount;
			booking_obj['markupamount_div'] = cal_obj.make_up_amount;
			booking_obj['value_fc'] = cal_obj.bill;
			booking_obj['value_div'] = cal_obj.bill;		

			/** radio holidings */
			booking_obj['pos_in_break'] = holding.pos_in_break;
			booking_obj['mat_key_identifier'] = holding.key_number;
			booking_obj['priority_modifier'] = holding.priority_modifier;
			booking_obj['med_ref_id'] = holding.media_ref;
			booking_obj['booked_date'] = holding.booked_date;
			booking_obj['booking_day_flags'] = holding.day_flags;
			booking_obj['booking_start_time'] = holding.start_time;
			booking_obj['booking_end_time'] = holding.end_time;
			booking_obj['prog_name'] = holding.program_name; 
			booking_obj['contract_ref'] = holding.contract_ref;
			booking_obj['network_code'] = holding.network_code;
			booking_obj['booking_duration'] = holding.duration;
			booking_obj['station_id'] = holding.station_link_id;

			return booking_obj;
		},
		async calculateBooking(item_obj, make_up_perc=0, rebate_perc=0) {
			const supplier_rate = Decimal(item_obj.rate_fc).toDecimalPlaces(Decimal_Places);
			const supplier_amount = supplier_rate.times(item_obj.units).toDecimalPlaces(Decimal_Places);
			const commission_rate = Decimal(item_obj.commission_perc).toDecimalPlaces(Decimal_Places);
			const commission_amount = supplier_amount.times(commission_rate).times(0.01).toDecimalPlaces(Decimal_Places);
			
			const ex_rate = 0;
			const ex_rate_cost_tmp = item_obj.cost_currency ? this.cost_rate_by_currency_id[`${item_obj.cost_currency.id}`] : 0;
			const ex_rate_cost = new Decimal(ex_rate_cost_tmp).toDecimalPlaces(Decimal_Places);
			
			const ex_rate_schedule_tmp = this.system_rate_by_job[`${item_obj.job_id}`].rate;
			const ex_rate_schedule = new Decimal(ex_rate_schedule_tmp).toDecimalPlaces(Decimal_Places);
			
			const supplier_amount_sys = supplier_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const commission_amount_sys = commission_amount.div(ex_rate_cost).toDecimalPlaces(Decimal_Places);
			const net_amount_sys = supplier_amount_sys.minus(commission_amount_sys).toDecimalPlaces(Decimal_Places);
			
			const net_amount_schedule = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_sys = net_amount_sys.times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
			const margin_amount_schedule = margin_amount_sys.times(ex_rate).toDecimalPlaces(Decimal_Places);

			const net_schedule = net_amount_schedule.plus(margin_amount_schedule).toDecimalPlaces(Decimal_Places);
			
			let make_up_amount = 0;
			let rebate = 0;
			if (item_obj.booking_mode === Markup_Mode) {
				const make_up_perc_tmp = new Decimal(make_up_perc).times(100).toDecimalPlaces(Decimal_Places);	
				make_up_amount = net_schedule.times(make_up_perc_tmp).div(100).toDecimalPlaces(Decimal_Places);
			} else if (item_obj.booking_mode === Commission_Mode) {
				make_up_amount = item_obj.cost_currency && item_obj.value_currency && item_obj.cost_currency.id !== item_obj.value_currency.id 
					? commission_amount.times(ex_rate_schedule).div(ex_rate_cost).toDecimalPlaces(Decimal_Places)
					: commission_amount;
			} else if (item_obj.booking_mode === Rebate_Mode) {
				const supplier_amount_tmp = item_obj.cost_currency && item_obj.value_currency && item_obj.cost_currency.id === item_obj.value_currency.id ? supplier_amount : supplier_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
				const commission_amount_tmp = item_obj.cost_currency && item_obj.value_currency && item_obj.cost_currency.id === item_obj.value_currency.id ? commission_amount : commission_amount.div(ex_rate_cost).times(ex_rate_schedule).toDecimalPlaces(Decimal_Places);
					
				make_up_perc = new Decimal(rebate_perc).toDecimalPlaces(Decimal_Places);
				rebate = supplier_amount_tmp.times(make_up_perc).div(100).toDecimalPlaces(Decimal_Places);
				make_up_amount = commission_amount_tmp.minus(rebate).toDecimalPlaces(Decimal_Places);
			} else {
				const make_up_perc_tmp = new Decimal(make_up_perc).times(100).toDecimalPlaces(Decimal_Places);	
				make_up_amount = net_schedule.times(make_up_perc_tmp).div(100).plus(commission_amount).toDecimalPlaces(Decimal_Places);
			}

			/** bill to client */
			const net_from_two_digital = Number(net_schedule.toFixed(2));
			const make_up_amount_two_digital = Number(make_up_amount.toFixed(2));
			const bill = make_up_amount_two_digital + net_from_two_digital;


			const calculate_obj = {
				supplier_rate: supplier_rate.toNumber(),
				supplier_amount: supplier_amount.toNumber(),
				commission_rate: commission_rate.toNumber(),
				commission_amount: commission_amount.toNumber(),
				ex_rate_cost: ex_rate_cost.toNumber(),
				ex_rate_schedule: ex_rate_schedule.toNumber(),
				margin_amount_schedule: margin_amount_schedule.toNumber(),
				net_schedule: net_schedule.toNumber(),
				make_up_amount: item_obj.booking_mode === Rebate_Mode ? rebate.toNumber() : make_up_amount.toNumber(),
				bill: bill
			};

			return calculate_obj;
		},
		calculateBookedDate(booked_date, day_flags) {
			let booking_start = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_start = current_date.format('YYYY-MM-DD');
							break;
						}
					}
				}
			}

			return booking_start;
		},
		calculateBookedEnd(booked_date, day_flags) {
			let booking_end = '';

			if (booked_date && day_flags && booked_date.length !== 0 && day_flags.length !== 0) {
				const start_date = moment(booked_date);

				let normalized_day_flags = typeof day_flags === 'string' ? day_flags : day_flags.join('');
				if (normalized_day_flags.length === 6) {
					normalized_day_flags = `${normalized_day_flags}0`;
				}

				if (start_date.isValid() && normalized_day_flags.length === 7) {
					for (let offset = 0; offset < 7; offset++) {
						const current_date = start_date.clone().add(offset, 'days');

						if (normalized_day_flags[current_date.day()] === '1') {
							booking_end = current_date.format('YYYY-MM-DD');
						}
					}
				}
			}

			return booking_end;
		},
		createBooking(params) {
			const url = '/api/media/media_planning'

			return new Promise((resolve, reject) => {
				axios
					.post(url, params, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							resolve(true);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		updateBooking(params, booking_id) {
			const url = `/api/media/media_planning/booking/${booking_id}`

			return new Promise((resolve, reject) => {
				axios
					.put(url, params, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							resolve(true);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		async bulkProcessMediaPlan(params) {
			const url = '/api/media/media_planning/import_export/bulk_process_radio_bookings';
			const processed_ids = [];
			const errors = [];

			for (let start_index = 0; start_index < params.length; start_index += Bulk_Process_Batch_Size) {
				const batch_params = params.slice(start_index, start_index + Bulk_Process_Batch_Size);

				try {
					const response = await axios.post(url, batch_params, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					});
					const { status, data, reason } = response.data;

					if (status === "OK") {
						if (Array.isArray(data)) {
							processed_ids.push(...data);
						} else if (data !== null && data !== undefined) {
							processed_ids.push(data);
						}
					} else {
						errors.push({
							message: reason
						});
					}
				} catch (e) {
					errors.push({
						message: e && e.message ? e.message : e
					});
				}
			}

			return {
				processed_ids: processed_ids,
				errors: errors
			};
		},
		bulkSetItemStatus(params) {
			const url = '/api/media/media_planning/import_export/bulk_set_item_status';

			return new Promise((resolve, reject) => {
				axios
					.post(url, params, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, reason } = json;

						if (status == "OK") {
							resolve(true);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		rejectBooking(holding_id, status) {
			const params = [];
			params.push('status=' + status);

			let url = `/api/media/media_planning/import_export/${holding_id}/set_item_status`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		isFallRange(date, date_range) {
			let is_fall_range = false;

			if (date_range.length === 0) {
				is_fall_range = true;
			} else {
				if (moment(date).isSame(date_range[0]) || moment(date).isSame(date_range[1]) || moment(date).isBetween(date_range[0], date_range[1])) {
					is_fall_range = true;
				}
			}

			return is_fall_range
		},
		getPaginationTotal(list_length) {
			return Math.ceil(list_length / this.countPerpage);
		},
		onPaginationInput(page, detail) {
			const start_index = (page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;
			const current_page_holdings = detail.holdings.slice(start_index, end_index);
			const current_page_holdings_filter = current_page_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.check = current_page_holdings_filter.length !== 0 && current_page_holdings_filter.every(holding => holding.checkbox === true);
			
			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });

			const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.active_num = active_item.length;

			const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.reject_num = reject_item.length;

			const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
			detail.copy_num = copy_item.length;
		},
		onClickOption(option, detail) {
			this.countPerpage = option;

			const start_index = (this.page - 1) * this.countPerpage;
			const end_index = start_index + this.countPerpage;
			const current_page_holdings = detail.holdings.slice(start_index, end_index);
			const current_page_holdings_filter = current_page_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject === Exception_Status });
			detail.check = current_page_holdings_filter.length !== 0 && current_page_holdings_filter.every(holding => holding.checkbox === true);

			const all_selected_holdings = detail.holdings.filter(holding => { return holding.checkbox === true });

			const active_item = all_selected_holdings.filter(holding => { return holding.phase && holding.outlet && holding.kind && holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.active_num = active_item.length;

			const reject_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 && holding.status_reject !== Reject_Status });
			detail.reject_num = reject_item.length;

			const copy_item = all_selected_holdings.filter(holding => { return holding.parent_id === 0 });
			detail.copy_num = copy_item.length;
		},
		checkFinish(detail_id) {
			this.getExceptionHoldings(this.fileId, detail_id, 1);
			this.getExceptionJobs(this.fileId, detail_id, true, 1);

			if (this.tid) {
				clearTimeout(this.tid);
			}
			this.tid = setTimeout(() => {
				this.visible_notice = false;
				this.notice_text = [];
				this.tid = null;
			}, 3000);
		},
		checkRejectFinish(detail_id) {
			const success_num = this.success_reject_ids.length;
			const error_num = this.error_reject_ids.length;
			const finish_num = success_num + error_num;

			if (finish_num === this.totle_reject_ids.length) {
				this.getExceptionHoldings(this.fileId, detail_id, 2);
				this.getExceptionJobs(this.fileId, detail_id, true, 2);

				this.visible_notice = false;
				this.notice_text = [];
			}
		},
		errorMessageFormat(msg) {
			let msg_str = msg;

			if (msg_str.includes(Error_Flag)) {
				msg_str = (msg_str.split(Error_Flag))[1];
			}
			
			return msg_str;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
	}
}
</script>

<style lang="scss" scoped>
.file-list-title {
  font-family: Roboto;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: -0.5px;
  color: #4742C6;
}
 .file-list-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
.button-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.5px;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	letter-spacing: 0.5px;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.5px;
}
.font-header-style {
	color: #192A3E;
}
.filter-menu-wrap {
	background-color: #FFFFFF;
}
.filter-menu-checkbox {
	margin-top: 0;
	padding-top: 0;
	min-height: 32px;
}
.filter-menu-label {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #192A3E;
}
.header-background-color {
	background-color: #EAEAEA;
}
.holding-cell {
	width: auto;
	min-width: 120px;
	max-width: 240px;
}
.holding-cell .row {
	min-width: 0;
	width: 100%;
}
.holding-cell .long-text {
	display: block;
	min-width: 0;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.holding-cell-checkbox {
	min-width: 50px;
	max-width: 50px;
}
.sticky-checkbox-column {
	position: sticky;
	left: 0;
	z-index: 2;
}
.sticky-checkbox-cell {
	background-color: #FFFFFF;
}
.sticky-checkbox-cell-child {
	background-color: #FAFAFF;
}
.sticky-checkbox-cell-reject {
	background-color: #FFEFEF;
}
.table-header-row {
	align-items: center;
	flex-wrap: nowrap;
	min-height: 60px;
}
.panel-icon {
	order: 0;
}
.panel-header {
	order: 1;
}
.phase-placeholder-red ::v-deep input::placeholder {
	color: #F45252 !important;
	opacity: 1;
}
.phase-select-auto-width {
	width: fit-content;
	min-width: 180px;
}
.phase-select-auto-width ::v-deep .v-input__control,
.phase-select-auto-width ::v-deep .v-input__slot {
	width: fit-content;
}
.phase-select-single-line {
	white-space: nowrap;
}
.truncate-2 {
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: initial;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}
.option-text {
	margin: 0 4px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #192A3E;
	&:hover {
		cursor: pointer;
	}
}
.panel-toggle-target {
	cursor: pointer;
}

::v-deep {
	.no-header-hover.v-expansion-panel-header,
	.no-header-hover.v-expansion-panel-header:hover {
		cursor: default;
	}
	.no-header-hover.v-expansion-panel-header:hover::before {
		opacity: 0;
	}
	.v-data-table__wrapper {
		overflow-x: auto;
	}
	table {
		width: max-content;
		min-width: 100%;
		table-layout: auto;
	}
	th,
	td {
		width: auto !important;
		white-space: nowrap;
		vertical-align: middle;
	}
	.v-expansion-panel-content__wrap {
		padding: 0 16px 0 !important;
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
	}
}
</style>
